<div class="td-wb-fine-print"
     role="region"
     aria-labelledby="td-wb-aria-fine-print-header"
     [class.td-wb-hide]="!hasItems()">
  <h2 class="td-wb-fine-print__header">
    <a role="button"
       tabindex="0"
       href=""
       class="td-wb-fine-print__header-link"
       (click)="onIconClick()"
       [attr.aria-expanded]="!collapsed">
      <td-wb-icon [iconId]="getIconId()"
                  size="24"
                  [inline]="true"
                  iconType="primary" />
      <span id="td-wb-aria-fine-print-header"
            class="td-wb-fine-print__header-label"
            translate="tdWb.fineprint.HEADER"></span>
    </a>
  </h2>
  <div class="td-wb-fine-print__item-group-container"
       [class.td-wb-hide]="collapsed">
    <div class="td-wb-fine-print__item-container"
         [attr.aria-hidden]="!hasItems('custom')"
         [class.td-wb-hide]="!hasItems('custom')">
      <ng-container>
        @for (custom of finePrints.customs; track custom) {
          <td-wb-fine-print-item itemType="custom">
            @if (!isContentComponent(custom)) {
              <span [innerHtml]="namespace + '.' + custom | tdWbTranslate"></span>
            }
            @if (isContentComponent(custom)) {
              <ng-container [cdkPortalOutlet]="getContentComponentPortal(custom)"
                            (attached)="setComponentInputs($event, custom)" />
            }
          </td-wb-fine-print-item>
        }
      </ng-container>
      <ng-content select="td-wb-fine-print-item:not([itemType])" />
    </div>
    <div class="td-wb-fine-print__item-container td-wb-fine-print__item-container--links"
         [attr.aria-hidden]="!hasItems('link')"
         [class.td-wb-hide]="!hasItems('link')">
      <ng-container>
        @for (link of finePrints.links; track link) {
          <td-wb-fine-print-item itemType="link">
            @if (!isContentComponent(link)) {
              <a class="td-wb-link"
                 [href]="namespace + '.' + link + '_URL' | tdWbTranslate"
                 target="_blank"
                 rel="noopener">
                <span [translate]="namespace + '.' + link"></span>
                <td-wb-icon iconId="new-page"
                            aria-hidden="true"
                            [inline]="true" />
              </a>
            }
            @if (isContentComponent(link)) {
              <ng-container [cdkPortalOutlet]="getContentComponentPortal(link)"
                            (attached)="setComponentInputs($event, link)" />
            }
          </td-wb-fine-print-item>
        }
      </ng-container>

      <ng-content select="td-wb-fine-print-item[itemType=link]" />
    </div>
    <div class="td-wb-fine-print__item-container td-wb-fine-print__item-container--footnotes"
         role="region"
         aria-labelledby="td-wb-aria-fine-print-footnotes-header"
         [attr.aria-hidden]="!hasItems('footnote')"
         [class.td-wb-hide]="!hasItems('footnote')">
      <h3 id="td-wb-aria-fine-print-footnotes-header"
          class="td-wb-fine-print__sub-header"
          translate="tdWb.fineprint.FOOTNOTES">
      </h3>
      @for (footnote of finePrints.footnotes; track $index) {
        <td-wb-fine-print-item itemType="footnote">
          @if (!isContentComponent(footnote)) {
            <span [innerHtml]="namespace + '.' + footnote | tdWbTranslate"></span>
          }
          @if (isContentComponent(footnote)) {
            <ng-container [cdkPortalOutlet]="getContentComponentPortal(footnote)"
                          (attached)="setComponentInputs($event, footnote)" />
          }
        </td-wb-fine-print-item>
      }
      <ng-content select="td-wb-fine-print-item[itemType=footnote]" />
    </div>
    <div class="td-wb-fine-print__item-container td-wb-fine-print__item-container--tips"
         role="region"
         aria-labelledby="td-wb-aria-fine-print-tips-header"
         [class.td-wb-hide]="!hasItems('tip')">
      <h3 id="td-wb-aria-fine-print-tips-header"
          class="td-wb-fine-print__sub-header"
          translate="tdWb.fineprint.TIPS">
      </h3>
      @for (tip of finePrints.tips; track tip) {
        <td-wb-fine-print-item itemType="tip">
          @if (!isContentComponent(tip)) {
            <span
              [translate]="namespace + '.' + tip"></span>
          }
          @if (isContentComponent(tip)) {
            <ng-container [cdkPortalOutlet]="getContentComponentPortal(tip)"
                          (attached)="setComponentInputs($event, tip)" />
          }
        </td-wb-fine-print-item>
      }
      <ng-content select="td-wb-fine-print-item[itemType=tip]" />
    </div>
    <div class="td-wb-fine-print__item-container td-wb-fine-print__item-container--pagenotes"
         role="region"
         aria-labelledby="td-wb-aria-page-notes-header"
         [attr.aria-hidden]="!hasItems('pagenote')"
         [class.td-wb-hide]="!hasItems('pagenote')">
      <h3 id="td-wb-aria-page-notes-header"
          class="td-wb-fine-print__sub-header"
          translate="tdWb.fineprint.PAGENOTES"></h3>
      @for (pageNote of finePrints.pagenotes; track pageNote) {
        <td-wb-fine-print-item itemType=pagenote>
          @if (!isContentComponent(pageNote)) {
            <span [innerHTML]="namespace + '.' + pageNote | tdWbTranslate"></span>
          }
          @if (isContentComponent(pageNote)) {
            <ng-container [cdkPortalOutlet]="getContentComponentPortal(pageNote)"
                          (attached)="setComponentInputs($event, pageNote)" />
          }
        </td-wb-fine-print-item>
      }
      <ng-content select="td-wb-fine-print-item[itemType=pagenote]" />
    </div>
    <div class="td-wb-fine-print__item-container td-wb-fine-print__item-container--disclaimers"
         role="region"
         aria-labelledby="td-wb-aria-fine-print-disclaimers-header"
         [attr.aria-hidden]="!hasItems('disclaimer')"
         [class.td-wb-hide]="!hasItems('disclaimer')">
      <h3 id="td-wb-aria-fine-print-disclaimers-header"
          class="td-wb-fine-print__sub-header"
          translate="tdWb.fineprint.DISCLAIMERS">
      </h3>
      @for (disclaimer of finePrints.disclaimers; track disclaimer) {
        <td-wb-fine-print-item itemType="disclaimer">
          @if (!isContentComponent(disclaimer)) {
            <span [innerHTML]="namespace + '.' + disclaimer | tdWbTranslate"></span>
          }
          @if (isContentComponent(disclaimer)) {
            <ng-container [cdkPortalOutlet]="getContentComponentPortal(disclaimer)"
                          (attached)="setComponentInputs($event, disclaimer)" />
          }
        </td-wb-fine-print-item>
      }
      <ng-content select="td-wb-fine-print-item[itemType=disclaimer]" />
    </div>
  </div>
</div>


